const USERFLOW_INITIALIZED = 'USERFLOW_INITIALIZED';

export const userflowInitializedAction = () => ({
  type: USERFLOW_INITIALIZED,
  isInitialized: true,
});

export type UserflowReducerState = {
  isInitialized: boolean;
};

const initialState: UserflowReducerState = {
  isInitialized: false,
};

export const userflowReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case USERFLOW_INITIALIZED:
      return {
        ...state,
        isInitialized: action.isInitialized,
      };

    default:
      return state;
  }
};
